import { Routes } from '@angular/router';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { NewPasswordComponent } from './components/new-password/new-password.component';

export const routes: Routes = [
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: '', redirectTo: '/forgot-password', pathMatch: 'full' },
  { path: 'new-password', component: NewPasswordComponent },
];
